import {IPagination} from "../_apiResponse";
import { Provider } from "../providers/_models";
import { Entity } from "app/models/entity";

export interface ReferentsPaginated extends IPagination<Referent>{}
export interface Referent extends Entity
{
    name: string
    surname: string
    email: string
    phone: string
    providers: Provider[]
}

export const emptyReferent = {
    id: 0,
    name: '',
    surname: '',
    email: '',
    phone: '',
    providers: []
}
